import DirectoryPicker, { DirectoryPickerProps } from '../../../../../../components/common/DirectoryPicker';
import MarkerText from '../../../../../components/inputs/MarkerText';
import { useSearchContext } from '../../../context/SettingsSearchContext';

export default function SettingsDirectoryPickerElement(props: Omit<DirectoryPickerProps, 'title'> & { title: string }) {
    const context = useSearchContext();
    return <DirectoryPicker {...props} title={<MarkerText highlight={context.term}>{props.title}</MarkerText>} className="px-3" />;
}
